import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const SourcesWrapper = styled(FlexDiv)`
  flex-direction: column;
  gap: 16px;
`;

export const Title = styled(Typography)`
  font-size: 20px;
  color: ${theme.colorsV2.primary.shade_900};
`;
